import { HOUR_EDITOR_DURATION_FORMAT } from 'constants/memory';
import { combinedDurationOfMemories } from 'factories/timeline';
import type { Duration } from 'types/units';
import { customDurationFormat } from './duration-helper';

export function isDurationEqualToSumOfMemories<
  T extends {
    id: number;
    from: string;
    to: string;
  },
>({
  duration,
  entries,
  memoryIds,
}: {
  duration: Duration;
  entries: Array<T>;
  memoryIds: Array<number>;
}): boolean {
  return (
    duration.formatted ===
    combinedDurationOfMemories(entries.filter(entry => memoryIds.includes(entry.id))).formatted
  );
}

export function processDurationOnChangeToMemories<
  T extends {
    id: number;
    from: string;
    to: string;
  },
>({
  entries,
  idsBefore,
  idsAfter,
  duration,
}: {
  entries: Array<T>;
  idsBefore: Array<number>;
  idsAfter: Array<number>;
  duration: Duration;
}): { changed: boolean; newDuration: Duration } {
  const durationMatchesSumOfMemories = isDurationEqualToSumOfMemories({
    duration,
    entries,
    memoryIds: idsBefore,
  });
  if (!durationMatchesSumOfMemories) {
    return { changed: false, newDuration: duration };
  }

  const newDuration = combinedDurationOfMemories(
    entries.filter(entry => idsAfter.includes(entry.id))
  );

  return {
    changed: true,
    newDuration,
  };
}

export function formatTicMemoryDrawerDuration(seconds: number): string {
  return customDurationFormat({
    value: seconds,
    valueType: 'seconds',
    trim: 'both',
    format: seconds >= 60 ? HOUR_EDITOR_DURATION_FORMAT : "s's'",
  });
}
